"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortCodeInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactPinInput = _interopRequireDefault(require("react-pin-input"));
var _sortCodeInputModule = _interopRequireDefault(require("./sort-code-input.module.scss"));
var LIBRARY_INPUT_STYLE_RESET = {
  padding: undefined,
  margin: undefined,
  textAlign: undefined,
  border: undefined,
  background: undefined,
  width: undefined,
  height: undefined
};
var LIBRARY_FOCUS_INPUT_STYLE_RESET = {
  outline: undefined,
  boxShadow: undefined
};
var SortCodeInput = function SortCodeInput(_ref) {
  var onChange = _ref.onChange,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    ariaLabel = _ref.ariaLabel,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue;
  var handleChange = (0, _react.useCallback)(function (value) {
    return onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_sortCodeInputModule.default['code-input'], (0, _defineProperty2.default)({}, _sortCodeInputModule.default['code-input--error'], error))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _sortCodeInputModule.default['code-input__divider']
  }, "\u2013"), /*#__PURE__*/_react.default.createElement("span", {
    className: _sortCodeInputModule.default['code-input__divider']
  }, "\u2013"), /*#__PURE__*/_react.default.createElement(_reactPinInput.default, {
    ariaLabel: ariaLabel,
    inputStyle: LIBRARY_INPUT_STYLE_RESET,
    inputFocusStyle: LIBRARY_FOCUS_INPUT_STYLE_RESET,
    inputMode: "numeric",
    length: 6,
    onChange: handleChange,
    initialValue: initialValue
  }));
};
exports.SortCodeInput = SortCodeInput;